import { useEffect } from 'react';
import { Logout } from 'src/services/authServices';

const InactiveUser = () => {

  //Check the curret time is greater then the stored time

  const checkForInactive = () => {
    const expireTime = localStorage.getItem("expireTime");
    if (expireTime < new Date().getTime()) {
      Logout();
    }
  }

  // Update expire time in session storage

  const updateExpireTime = () => {
    const expireTime = new Date().getTime() + 28800000; // 8 hrs = 28800000 ms
    localStorage.setItem("expireTime", expireTime)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      checkForInactive();
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  //Update Expire time on user activity
  useEffect(() => {
    updateExpireTime();
    window.addEventListener("click", updateExpireTime)
    window.addEventListener("keypress", updateExpireTime)
    window.addEventListener("keydown", updateExpireTime)
    window.addEventListener("scroll", updateExpireTime)
    window.addEventListener("mousemove", updateExpireTime)

    return () => {
      window.removeEventListener("click", updateExpireTime)
      window.removeEventListener("keypress", updateExpireTime)
      window.removeEventListener("keydown", updateExpireTime)
      window.removeEventListener("scroll", updateExpireTime)
      window.removeEventListener("mousemove", updateExpireTime)
    }

  }, [])

  return null;
};

export default InactiveUser;
